import Call from '../Call.v2';

const BidderWinRateConfig = {
    get() {
        return Call(`bidder/winRate/config`);
    },
    save(source, enabled) {
        return Call(`bidder/winRate/config`,'POST', { source, enabled });
    },
};

export default BidderWinRateConfig;


// WEBPACK FOOTER //
// ./src/services/API/components/BidderWinRateConfig.js